// extracted by mini-css-extract-plugin
export default {"name":"styles_name__QeJsa","designation":"styles_designation__7Bkao","img":"styles_img__SzYZ7"};